<div class="title">
  <div class="wavy-line"></div>
  @if(language == 'Ar'){
  <p class="text text--ar">{{ input_title() }}</p>
  } @else {
  <p class="text">{{ input_title() }}</p>
  }
  <div class="wavy-line"></div>
</div>
